import { render, staticRenderFns } from "./GFrameFormInput.vue?vue&type=template&id=3f5045e2&scoped=true&"
import script from "./GFrameFormInput.vue?vue&type=script&lang=ts&"
export * from "./GFrameFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GFrameFormInput.vue?vue&type=style&index=0&id=3f5045e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5045e2",
  null
  
)

export default component.exports